import React from 'react';
import '../template-file-css/document-file-template.css';


export const AJC_AuthorizationReleaseInformation = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='AJC_AuthorizationReleaseInformation' className='file-pdf-document'>
            <div className='file-template'>
        <h2>SECTION A: </h2>
        <h3>Use or Disclosure of Health Information</h3>
           <p className='w-750'>By signing this form, I authorize the use and/or disclosure of my individually identifiable health information maintained by: </p>
           <p className='w-750'>(This form can be used bilaterally to send and receive health information, please indicate the names and addresses below and check of <strong>To</strong> and <strong>Among</strong> boxes below.)</p>
           <p className='w-750'>
                 <span className='eleHeader'>Name:</span>
                 <input type="text" id="txtName" name="txtName" className='add-only' />
           </p>
           <p className='w-750'>
                 <span className='eleHeader'>Address:</span>
                 <input type="text" id="txtAddress" name="txtAddress" className='add-only' />
           </p>
        <h3 className='w-750'>My health information may be disclosed  <u>TO </u>   or  <u>AMONG </u> all of the following that I have checked:   </h3>
            <table>
               <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_A_Box1" name="cbSection_A_Box1" className='add-only' value="Section_A_Box1" />Probation Department                              
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_A_Box2" name="cbSection_A_Box2" className='add-only' value="Section_A_Box2" />Superior Court                       
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_A_Box3" name="cbSection_A_Box3" className='add-only' value="Section_A_Box3" />Juvenile Court                       
                        </td>
               </tr>
               <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_A_Box4" name="cbSection_A_Box4" className='add-only' value="Section_A_Box4" />Department of Juvenile Justice                                             
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_A_Box5" name="cbSection_A_Box5" className='add-only' value="Section_A_Box5" />Schools                        
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_A_Box6" name="cbSection_A_Box6" className='add-only' value="Section_A_Box6" />City Schools                       
                        </td>
               </tr>
               <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_A_Box7" name="cbSection_A_Box7" className='add-only' value="Section_A_Box7" />Community Service Board                                                                   
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_A_Box8" name="cbSection_A_Box8" className='add-only' value="Section_A_Box8" />Department of Family & Children Services                        
                        </td>
               </tr>
               <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSection_A_BoxOther" name="cbSection_A_BoxOther" className='add-only' value="Section_A_BoxOther" />Other:
                            <input type="text" id="txtSection_A_Box_other" name="txtSection_A_Box_other" placeholder='A Journey for Change, LLC' className='add-only' /> 
                                                                                             
                        </td>
                </tr>
            </table>
            <p className='w-750'>
                 <span className='eleHeader'>Address:</span>
                 <input type="text" id="txtSection_A_BoxAddress" name="txtSection_A_BoxAddress"placeholder='650 9th Avenue NW , Bessemer, AL 35022 ' className='add-only' />
           </p>
           <p className='w-750'>
                 <span className='eleHeader'>Phone :</span>
                 <input type="text" id="txtSection_A_BoxPhone" name="txtSection_A_BoxPhone"placeholder='205-267-4463(office) 205-800-7022 (fax)' className='add-only' />
           </p>
        <h2>SECTION B: </h2>
        <h3>Scope and use of Disclosure:</h3>
        <p className='w-750'>Information that may be used or disclosed based on this authorization is as follows (Check only those applicable to this use or disclosure.)</p>
        <table>
               <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_B_Box1" name="cbSection_B_Box1" className='add-only' value="Section_B_Box1" /> Attendance                                      
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_B_Box2" name="cbSection_B_Box2" className='add-only' value="Section_B_Box2" />Drug Screen Results                                      
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_B_Box3" name="cbSection_B_Box3" className='add-only' value="Section_B_Box3" />Discharge Summary                                
                        </td>
               </tr>
               <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_B_Box4" name="cbSection_B_Box4" className='add-only' value="Section_B_Box4" />Psychiatric Evaluation                                               
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_B_Box5" name="cbSection_B_Box5" className='add-only' value="Section_B_Box5" />ISP                       
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_B_Box6" name="cbSection_B_Box6" className='add-only' value="Section_B_Box6" />Physician Orders                                
                        </td>
               </tr>
               <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_B_Box7" name="cbSection_B_Box7" className='add-only' value="Section_B_Box7" />Treatment Summary                                                                              
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_B_Box8" name="cbSection_B_Box8" className='add-only' value="Section_B_Box8" />Lab Reports                                                        
                        </td>
               </tr>
               <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSection_B_Box9" name="cbSection_B_Box9" className='add-only' value="Section_B_Box9" />Physical Examination & Nursing Assessment                                                                                  
                        </td>
                </tr>
               <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSection_B_Box10" name="cbSection_B_Box10" className='add-only' value="Section_B_Box10" />Information pertaining to testing&/or treatment related to HIV or AIDS and any related conditions.                                                       
                        </td>
               </tr>
                
                <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSection_B_Box11" name="cbSection_B_Box11" className='add-only' value="Section_B_Box11" />Privileged communications between licensed professional staff and me or between them concerning my communications with any of them.                                                                                 
                        </td>
                </tr>
               <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSection_B_BoxOther" name="cbSection_B_BoxOther" className='add-only' value="Section_B_BoxOther" />Other:
                            <input type="text" id="txtSection_B_Box_other" name="txtSection_B_Box_other" className='add-only' /> 
                                                                                             
                        </td>
                </tr>
            </table>
     <h2>SECTION C: </h2>
        <h3>For the purpose of</h3>
        <table>
               <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_C_Box1" name="cbSection_C_Box1" className='add-only' value="Section_C_Box1" /> Requirements of the Court                                            
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_C_Box2" name="cbSection_C_Box2" className='add-only' value="Section_C_Box2" />Probation/Parole                                             
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_C_Box3" name="cbSection_C_Box3" className='add-only' value="Section_C_Box3" />DHR Requirement                                   
                        </td>
               </tr>
               <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_C_Box4" name="cbSection_C_Box4" className='add-only' value="Section_C_Box4" />Family Involvement                                                                    
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSection_C_Box5" name="cbSection_C_Box5" className='add-only' value="Section_C_Box5" />Continuity of Care                            
                        </td>
                 </tr>
                 <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbSection_C_BoxOther" name="cbSection_C_BoxOther" className='add-only' value="Section_C_BoxOther" />Other:
                            <input type="text" id="txtSection_C_Box_other" name="txtSection_C_Box_other" className='add-only' /> 
                                                                                             
                        </td>
                </tr>
        </table>
        <h2>SECTION D:</h2>
        <p className='w-750'>Date or event in which authorization expires:  <strong>1 year from date of SignatureNOTE: </strong> If an expiration event is used, the event must relate to the consumer or the purpose for the disclosure.</p>
             <h2>SECTION E: </h2>
             <h3>Other Important Information</h3>
             <p className='w-750'><ol>
                   <li>I understand that A JOURNEY FOR CHANGE, LLC (AJC) cannot guarantee that the recipient of this information will not re-disclose this information to a third party.   The recipient may not be subject to federal laws governing privacy of health information. </li>
                   <li>However, if the disclosure consists of treatment information about a client in an alcohol or drug abuse program, the recipient is prohibited under federal law from making </li>
                   <li>further disclosure of such information unless further disclosure is expressly permitted by written consent of the client or as otherwise permitted by federal governing confidentiality of alcohol and abuse patient records (42CFR, Part 2).  </li>
                   <li>I understand that when I am receiving health care only for the purpose of creating information for disclosure to a third party, I may refuse to sign this Authorization and that my refusal will not affect my ability to obtain treatment from A JOURNEY FOR CHANGE, LLC.</li>
                   <li>I understand that I may revoke this authorization before written notice of revocation is received. (Notice of Privacy Practices)</li>
               </ol></p>
               
               <table>
                   <tr>
                        <td className='w-500 signature'  >&nbsp;
                        </td>
                        <td className='w-250 signature'  >&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className=" w-500 small">Signature of Client                                                                       
                        </td>
                        <td className="w-250 small">Date:
                        </td>
                    </tr>
            </table>
            <table>
                   <tr>
                        <td className='w-500 signature'  >&nbsp;
                        </td>
                        <td className='w-250 signature'  >&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className=" w-500 small">Signature of Parent or Legal Guardian                                                                                                                   
                        </td>
                        <td className="w-250 small">Date:
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500 signature'  >&nbsp;
                        </td>
                        <td className='w-250 signature'  >&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className=" w-500 small">Signature of Witness                                                                                                                  
                        </td>
                        <td className="w-250 small">Date:
                        </td>
                    </tr>
            </table>  
                   
            </div>
        </form>
        

    )
}
                  
                        